import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { EVENT } from '../../../shared/constants/dali.constants';
import { ForeignCurrencyModel } from '../../../shared/models/abre-cuentas.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
var FOREIGN_CURRENCY = 'foreignCurrency';
var ForeignCurrencyComponent = /** @class */ (function () {
    function ForeignCurrencyComponent(copyService, headerService, taggingService, navigationService, bitacoraService, abreCuentasService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.taggingService = taggingService;
        this.navigationService = navigationService;
        this.bitacoraService = bitacoraService;
        this.abreCuentasService = abreCuentasService;
        this.foreignCurrency = new ForeignCurrencyModel();
        this.stateButton = false;
        this.headerService.show(true, true, true);
        this.listForeignCurrency = [
            { label: copyService.copies.foreign_currency_radio_yes, elementId: 1, checked: false },
            { label: copyService.copies.foreign_currency_radio_no, elementId: 2, checked: true },
        ];
    }
    ForeignCurrencyComponent.prototype.ngOnInit = function () {
        this.getData();
    };
    /**
     * Summary Function to charge predefined data by attribute IsPep
     */
    ForeignCurrencyComponent.prototype.getData = function () {
        var e_1, _a;
        if (this.abreCuentasService.getForeignCurrency() === undefined
            || this.abreCuentasService.getForeignCurrency().elementId === undefined) {
            this.foreignCurrency = {
                elementId: 2,
                value: this.copyService.copies.foreign_currency_radio_no,
                checked: true,
            };
            this.abreCuentasService.setForeignCurrency(this.foreignCurrency);
        }
        else {
            this.foreignCurrency = this.abreCuentasService.getForeignCurrency();
            try {
                for (var _b = tslib_1.__values(this.listForeignCurrency), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var foreignCurrency = _c.value;
                    foreignCurrency.checked = foreignCurrency.elementId === this.foreignCurrency.elementId ? this.foreignCurrency.checked : false;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    /**
     * Summary Set propertys to foreignCurrency
     * @param event
     */
    ForeignCurrencyComponent.prototype.selectradioforeignCurrency = function (event, selectedObject) {
        if (event.checked) {
            this.foreignCurrency = {
                elementId: selectedObject.elementId,
                value: selectedObject.label,
                checked: true,
            };
        }
        this.abreCuentasService.setForeignCurrency(this.foreignCurrency);
    };
    ForeignCurrencyComponent.prototype.clickInfo = function () {
        this.taggingService.setTagId('', 'pv199', 'pv180', '');
        var tagPageName = this.taggingService.getTagIdByProduct();
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.header,
                    type: EVENT.customCategory.type.tooltip,
                    position: EVENT.customCategory.position.top,
                },
                action: EVENT.customAction.click,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log(error);
        }
    };
    /**
     * Summary Go to next Step
     */
    ForeignCurrencyComponent.prototype.next = function () {
        this.abreCuentasService.setForeignCurrency(this.foreignCurrency);
        this.sendDataToBitacora();
        if (this.foreignCurrency.elementId === 1) {
            this.navigationService.nextStep('200');
            this.navigationService.getCurrentPhase().steps['foreign-products'].previous = 'operation-currency';
        }
        else {
            this.navigationService.nextStep('201');
            this.navigationService.getCurrentPhase().steps['foreign-products'].previous = 'foreign-currency';
        }
    };
    ForeignCurrencyComponent.prototype.sendDataToBitacora = function () {
        var strDataToSend = FOREIGN_CURRENCY + " " + (this.foreignCurrency.elementId === 1) ? 'Si' : 'No';
        this.bitacoraService.saveDataInBitacora(strDataToSend);
    };
    return ForeignCurrencyComponent;
}());
export { ForeignCurrencyComponent };
